import { FilterState } from '../../../../common/components/TableToolbar/FilterPopover';
export const customFilterColumnsGenerator = (binderCustomColumns, binderStudiesSponsors, binderStudiesCros, binderStudiesBinderTypes, binderStudiesDiseaseGroups, binderStudiesContacts, binderStudiesSites, binderStudiesDepartments, binderStudiesSiteNumbers, binderStudiesPrincipalInvestigators) => {
    return [
        {
            title: getTitleFromCustomColumns(binderCustomColumns, 'sponsor') || 'Sponsor',
            field: 'sponsor',
            key: 'sponsor',
            hidden: true,
            toolbarFilter: FilterState.MULTISEARCHLIST,
            toolbarFilterData: binderStudiesSponsors
                .filter(item => item !== null && item !== '')
                .map(item => ({
                    label: `${item}`,
                    key: `${item}`,
                })),
        },
        {
            title: getTitleFromCustomColumns(binderCustomColumns, 'cro') || 'CRO',
            field: 'cro',
            key: 'cro',
            hidden: true,
            toolbarFilter: FilterState.MULTISEARCHLIST,
            toolbarFilterData: binderStudiesCros
                .filter(item => item !== null && item !== '')
                .map(item => ({
                    label: `${item}`,
                    key: `${item}`,
                })),
        },
        {
            title: getTitleFromCustomColumns(binderCustomColumns, 'binder_type') || 'Binder Type',
            field: 'binder_type',
            key: 'binder_type',
            hidden: true,
            toolbarFilter: FilterState.MULTISEARCHLIST,
            toolbarFilterData: binderStudiesBinderTypes
                .filter(item => item !== null && item !== '')
                .map(item => ({
                    label: `${item}`,
                    key: `${item}`,
                })),
        },
        {
            title: getTitleFromCustomColumns(binderCustomColumns, 'disease_group') || 'Disease Group',
            field: 'disease_group',
            key: 'disease_group',
            hidden: true,
            toolbarFilter: FilterState.MULTISEARCHLIST,
            toolbarFilterData: binderStudiesDiseaseGroups
                .filter(item => item !== null && item !== '')
                .map(item => ({
                    label: `${item}`,
                    key: `${item}`,
                })),
        },
        {
            title: getTitleFromCustomColumns(binderCustomColumns, 'contact') || 'Contact',
            field: 'contact',
            key: 'contact',
            hidden: true,
            toolbarFilter: FilterState.MULTISEARCHLIST,
            toolbarFilterData: binderStudiesContacts
                .filter(item => item !== null && item !== '')
                .map(item => ({
                    label: `${item}`,
                    key: `${item}`,
                })),
        },
        {
            title: getTitleFromCustomColumns(binderCustomColumns, 'site') || 'Site',
            field: 'site',
            key: 'site',
            hidden: true,
            toolbarFilter: FilterState.MULTISEARCHLIST,
            toolbarFilterData: binderStudiesSites
                .filter(item => item !== null && item !== '')
                .map(item => ({
                    label: `${item}`,
                    key: `${item}`,
                })),
        },
        {
            title: getTitleFromCustomColumns(binderCustomColumns, 'department') || 'Department',
            field: 'department',
            key: 'department',
            hidden: true,
            toolbarFilter: FilterState.MULTISEARCHLIST,
            toolbarFilterData: binderStudiesDepartments
                .filter(item => item !== null && item !== '')
                .map(item => ({
                    label: `${item}`,
                    key: `${item}`,
                })),
        },
        {
            title: getTitleFromCustomColumns(binderCustomColumns, 'site_number') || 'Site Number',
            field: 'site_number',
            key: 'site_number',
            hidden: true,
            toolbarFilter: FilterState.MULTISEARCHLIST,
            toolbarFilterData: binderStudiesSiteNumbers
                .filter(item => item !== null && item !== '')
                .map(item => ({
                    label: `${item}`,
                    key: `${item}`,
                })),
        },
        {
            title: getTitleFromCustomColumns(binderCustomColumns, 'principal_investigator') || 'Principal Investigator',
            field: 'principal_investigator',
            key: 'principal_investigator',
            hidden: true,
            toolbarFilter: FilterState.MULTISEARCHLIST,
            toolbarFilterData: binderStudiesPrincipalInvestigators
                .filter(item => item !== null && item !== '')
                .map(item => ({
                    label: `${item}`,
                    key: `${item}`,
                })),
        },
    ];

};

const getTitleFromCustomColumns = (binderCustomColumns, key) => {
    const customColumn = binderCustomColumns && binderCustomColumns.find(column => column.key === key);
    return customColumn ? customColumn.label : null;
};